[
  { "label": "Behance", "value": "behance" },
  { "label": "Discord", "value": "discord" },
  { "label": "Dribbble", "value": "dribbble" },
  { "label": "Facebook", "value": "facebook" },
  { "label": "Github", "value": "github" },
  { "label": "Instagram", "value": "instagram" },
  { "label": "LinkedIn", "value": "linkedin" },
  { "label": "Medium", "value": "medium" },
  { "label": "Other", "value": "other" },
  { "label": "RedNote", "value": "rednote" },
  { "label": "SoundCloud", "value": "soundcloud" },
  { "label": "Spotify", "value": "spotify" },
  { "label": "TikTok", "value": "tiktok" },
  { "label": "Twitter", "value": "twitter" },
  { "label": "Vimeo", "value": "vimeo" },
  { "label": "VSCO", "value": "vsco" },
  { "label": "Youtube", "value": "youtube" }
]
